import { Body4 } from '../../../app/common/typography';
import styled from 'styled-components';

export const ActionTextWrapper = styled(Body4)`
  display: inline;
  font-weight: ${({ theme }) => theme.fontWeight.semiBold};
`;
